// Module
var code = `<ng-form name="\$ctrl.form">
  <validator condition="\$ctrl.allDocumentNumberAreValid()"></validator>

  <div class="form-column" ng-repeat="doc in \$ctrl.idDocuments track by \$index">
    <form-section form-title="'Document ' + (\$index + 1) + ''">
      <form-section-field field-title="'Type'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'type')">
        <select ng-required="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'type')"
                ng-model="doc.selectedDocumentType"
                ng-disabled="!\$ctrl.editMode"
                ng-change="\$ctrl.documentTypeChanged(doc)"
                ng-options="entry.description for entry in \$ctrl.allowedDocumentTypes">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Status'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'status')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'status')"
                ng-model="doc.documentStatusId"
                ng-disabled="!\$ctrl.editMode"
                ng-options="entry.id as entry.description for entry in \$ctrl.getStatusDict(doc)">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Number'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'number')">
        <input ng-required="!doc.documentNumberOptional && \$ctrl.cfg.required(\$ctrl.module, 'document', 'number')"
               ng-class="{'nx-invalid': !\$ctrl.isDocumentNumberValid(doc)}"
               ng-model="doc.documentNumber"
               ng-pattern="/^[0-9a-zA-Z_-]+\$/"
               maxlength="64"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               placeholder="Document number">
      </form-section-field>
      <form-section-field field-title="'Name'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'name')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'name')"
               ng-model="doc.documentName"
               maxlength="64"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               placeholder="Document name">
      </form-section-field>
      <form-section-field field-title="'Issuing authority'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'issuing_authority')">
        <input ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'issuing_authority')"
               ng-model="doc.issuingAuthority"
               maxlength="64"
               ng-disabled="!\$ctrl.editMode"
               type="text"
               placeholder="Issuing Authority">
      </form-section-field>
      <form-section-field field-title="'Issuing country'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'issuing_country')">
        <select ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'issuing_country')"
                ng-model="doc.countryId"
                ng-disabled="!\$ctrl.editMode"
                ng-options="entry.id as entry.description for entry in \$ctrl.dict.COUNTRY">
          <option></option>
        </select>
      </form-section-field>
      <form-section-field field-title="'Issuance date'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'issuance_date')">
        <date output-format="local-date"
              validate-date="lte:posting-date"
              init-with-null="true"
              ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'issuance_date')"
              ng-model="doc.issuanceDate"
              ng-disabled="!\$ctrl.editMode"></date>
      </form-section-field>
      <form-section-field field-title="'Submission date'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'submission_date')">
        <date output-format="date"
          validate-date="lte:posting-date"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'submission_date')"
          ng-model="doc.dateSubmitted"
          ng-disabled="!\$ctrl.editMode"></date>
      </form-section-field>
      <form-section-field field-title="'Expiration date'" ng-if="doc.expirationSupported && \$ctrl.cfg.visible(\$ctrl.module, 'document', 'expiration_date')">
        <date output-format="date"
          ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'expiration_date')"
          ng-model="doc.expirationDate"
          ng-disabled="!\$ctrl.editMode"></date>
      </form-section-field>
      <form-section-field field-title="'Document photo'"
                          ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'document_upload')">
      <file-upload ng-model="doc.photos"
                   ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'document_upload')"
                   validate-uploaded
                   max-files="\$ctrl.maxFiles"
                   name="documentUpload"
                   ng-disabled="!\$ctrl.editMode"
                   show-file-name="true"
                   show-remarks="false">
      </file-upload>
      </form-section-field>
      <form-section-field field-title="'Remarks'" ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'document', 'remarks')">
        <textarea ng-required="\$ctrl.cfg.required(\$ctrl.module, 'document', 'remarks')"
                  ng-model="doc.remarks"
                  maxlength="512"
                  ng-disabled="!\$ctrl.editMode"
                  placeholder="Remarks">
        </textarea>
      </form-section-field>
    </form-section>

    <div ng-show="\$ctrl.editMode" ng-if="\$ctrl.module !== 'agent' || !doc.id">
      <button type="button" class="btn btn-danger btn--align-with-form-field" ng-click="\$ctrl.removeDocument(doc)">
        Remove document
      </button>
    </div>
  </div>

  <div class="form-column" ng-show="\$ctrl.editMode">
    <form-section form-title="'Add new document'">
      <button type="button" class="btn btn-primary btn--align-with-form-field" ng-click="\$ctrl.addDocument()">
        Add new document
      </button>
    </form-section>
  </div>

  <!-- document count validation -->
  <div ng-if="\$ctrl.documentRequired && \$ctrl.idDocuments.length < \$ctrl.minDocsSections">
    <input class="hidden-element" disabled ng-required="true" ng-model="nonExistingValue"/>
  </div>

</ng-form>

<div class="clearfix"></div>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/documents.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;